function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Frame_12",
  "data-name": "Frame 12",
  transform: "translate(-14 -7)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_5",
  "data-name": "Group 5"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_3",
  "data-name": "Ellipse 3",
  cx: 17,
  cy: 17,
  r: 17,
  transform: "translate(14 7)",
  fill: "#9c9c9c"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_10",
  "data-name": "Path 10",
  d: "M33.98,15.923a.781.781,0,0,0-.558,1.46,7.264,7.264,0,1,1-5.189,0,.781.781,0,1,0-.558-1.459,8.827,8.827,0,1,0,6.306,0Z",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.6
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11",
  "data-name": "Path 11",
  d: "M30.828,13a.781.781,0,0,0-.781.781v7.65a.781.781,0,1,0,1.562,0v-7.65a.781.781,0,0,0-.78-.782Z",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.6
}));

function SvgDeviceOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceOff);
export default __webpack_public_path__ + "static/media/device-off.0a4b23d3.svg";
export { ForwardRef as ReactComponent };